/**
 * @generated SignedSource<<456433768da14bab7a29fc199bc892f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type LogJobDataProviderQuery$variables = {
  isRegionalManager?: boolean | null;
};
export type LogJobDataProviderQuery$data = {
  readonly getLocationList: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
    readonly uuid: string | null;
  }>;
  readonly getLocationTypes: ReadonlyArray<{
    readonly description: string | null;
    readonly id: string;
    readonly isDefault: boolean | null;
    readonly name: string;
  }>;
  readonly getMachineList: ReadonlyArray<{
    readonly id: string;
    readonly locationId: string | null;
    readonly name: string | null;
    readonly serialNumber: string;
    readonly uuid: string | null;
  }>;
  readonly getMarketingMaterials: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
    readonly priority: number;
  }>;
  readonly getUsers: ReadonlyArray<{
    readonly firstName: string;
    readonly id: string;
    readonly isActive: boolean;
    readonly isRegionalManager: boolean;
    readonly lastName: string | null;
  }>;
};
export type LogJobDataProviderQuery = {
  response: LogJobDataProviderQuery$data;
  variables: LogJobDataProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isRegionalManager"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LocationObjectType",
    "kind": "LinkedField",
    "name": "getLocationList",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "MachineObjectType",
    "kind": "LinkedField",
    "name": "getMachineList",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "serialNumber",
        "storageKey": null
      },
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "locationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "isRegionalManager",
        "variableName": "isRegionalManager"
      }
    ],
    "concreteType": "UserObjectType",
    "kind": "LinkedField",
    "name": "getUsers",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isActive",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isRegionalManager",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "MarketingMaterialsObjectType",
    "kind": "LinkedField",
    "name": "getMarketingMaterials",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "priority",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "LocationTypeObjectType",
    "kind": "LinkedField",
    "name": "getLocationTypes",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isDefault",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LogJobDataProviderQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LogJobDataProviderQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "896e53d7c342df24bbfe9fc2593d65ba",
    "id": null,
    "metadata": {},
    "name": "LogJobDataProviderQuery",
    "operationKind": "query",
    "text": "query LogJobDataProviderQuery(\n  $isRegionalManager: Boolean\n) {\n  getLocationList {\n    id\n    uuid\n    name\n  }\n  getMachineList {\n    id\n    uuid\n    serialNumber\n    name\n    locationId\n  }\n  getUsers(isRegionalManager: $isRegionalManager) {\n    id\n    firstName\n    lastName\n    isActive\n    isRegionalManager\n  }\n  getMarketingMaterials {\n    id\n    name\n    priority\n  }\n  getLocationTypes {\n    id\n    name\n    description\n    isDefault\n  }\n}\n"
  }
};
})();

(node as any).hash = "09f319a7fd37f04a99972d03ddb6131f";

export default node;
